<template>
  <app-action-bar
    :menu-items="actionBarItems"
    :selected-items="selectedTasks"
    :selected-items-label-path="selectedItemsLabelPath"
    data-locator="multi-select-bar" 
    @clear-selection="onClearSelection"
  >
    <app-action-bar-list-item 
      v-for="item in actionBarItems"
      :item="item"
      :key="item.name"
    />
  </app-action-bar>

  <ChecklistDeleteSelectionDialog
      v-if="isDeleteSelectionDialogOpened"
      @close="isDeleteSelectionDialogOpened = false"
  />

  <ChecklistStatusDialog
    v-if="isStatusDialogOpened"
    :mnemo="roomMnemo"
    :tasks="selectedTasks"
    @clear-selection="onClearSelection"
    @close="isStatusDialogOpened = false" 
  />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import ChecklistDeleteSelectionDialog from '@/project/checklist/dialogs/ChecklistDeleteSelectionDialog.vue'
import ChecklistStatusDialog from '@/project/checklist/dialogs/ChecklistStatusDialog.vue'
import { CLEAR_ITEMS_SELECTION } from '@/store/modules/checklist/action_types'
import { SET_SHARE_TASKS_DIALOG } from '@/store/modules/checklist/mutation_types'

const TRANSLATION_KEY_PREFIX = 'project.checklist.ChecklistActionBar'

export default {
  name: 'ChecklistActionBar',
  components: {
    ChecklistDeleteSelectionDialog,
    ChecklistStatusDialog,
  },
  data () {
    return {
      isDeleteSelectionDialogOpened: false,
      isStatusDialogOpened: false,
      TRANSLATION_KEY_PREFIX,
    }
  },
  computed: {
    ...mapGetters('checklist', ['selectedTasks', 'isValidatorOfAllSelectedTasks', 'isResponsibleOfAllSelectedTasks']),
    ...mapGetters('room', ['isCurrentUserPm', 'roomMnemo']),

    actionBarItems () {
      return [
        {
          action: this.openStatusDialog,
          icon: 'circle-dashed',
          name: 'status',
          title: this.$t(`${TRANSLATION_KEY_PREFIX}.status`),
          locatorValue: 'status-button',
          disabled: !this.isCurrentUserPm && !this.isValidatorOfAllSelectedTasks && !this.isResponsibleOfAllSelectedTasks,
          disabledTooltip: this.$t(`${TRANSLATION_KEY_PREFIX}.statusDisabledTooltip`),
        },
        {
          action: this.openShareSelectionDialog,
          icon: 'user-lock',
          name: 'share',
          title: this.$t('common.share'),
          locatorValue: 'share-button',
          hidden: !this.isCurrentUserPm,
        },
        {
          action: this.openDeleteDialog,
          icon: 'trash-alt',
          name: 'delete',
          title: this.$t('common.delete'),
          locatorValue: 'delete-bar-item',
          style: 'text-error',
          variant: 'danger',
          hidden: !this.isCurrentUserPm,
        },
      ]
    },
    selectedItemsLabelPath () {
      return `${TRANSLATION_KEY_PREFIX}.selectedItemsLabel`
    },
  },
  beforeUnmount () {
    this.CLEAR_ITEMS_SELECTION()
  },
  methods: {
    ...mapActions('checklist', [CLEAR_ITEMS_SELECTION]),
    ...mapMutations('checklist', [SET_SHARE_TASKS_DIALOG]),
    onClearSelection () {
      this.CLEAR_ITEMS_SELECTION()
    },
    openDeleteDialog () {
      this.isDeleteSelectionDialogOpened = true
    },
    openStatusDialog () {
      this.isStatusDialogOpened = true
    },
    openShareSelectionDialog () {
      this.SET_SHARE_TASKS_DIALOG({
        isOpen: true,
        tasksToShare: this.selectedTasks,
      })
    },
  },
}
</script>
